/* Live bracelet preview for register products (LIVE for all customers since
 * 14 Sep 2026, owner sign-off "turn it on for other listings"; was gated by
 * ?bbprev=1 during the pilot).
 * Reads the register's own selections (bead size, pixiu, charm) plus the
 * preview block's pearl / pair controls, and draws the ring with the SAME
 * geometry as the custom 2D builder (constants ported from
 * bracelet-builder-2d-v2.js - do not re-derive them here). */
(function () {
  var wrap = document.querySelector('[data-pbprev]');
  if (!wrap) return;
  /* SIMPLE mode (owner, 29 Oct 2026): plain bead bracelets on the
     simple-serenity template draw the same preview from the theme's own
     variant pickers - no register on the page. Only products offering BOTH
     a wrist size and a bead size qualify: statues and necklaces share the
     template and must never see the block (ungating without this check
     leaked the empty preview onto them once - commit 6ac94f6). */
  function themeOptionInputs(optName) {
    var vr = document.querySelector('variant-radios');
    if (!vr) return [];
    return [].slice.call(vr.querySelectorAll('input[type="radio"][name="' + optName + '"]'));
  }
  /* the sticky add-to-cart form duplicates the pickers and the two copies
     do NOT stay checked in sync - trust the input the customer last
     changed, falling back to the first form's checked state at load */
  var SIMPLE_SEL = {};
  function themeChecked(optName) {
    if (SIMPLE_SEL[optName] != null) return { value: SIMPLE_SEL[optName], checked: true };
    return themeOptionInputs(optName).filter(function (i2) { return i2.checked; })[0] || null;
  }
  var SIMPLE = false;
  if (!document.querySelector('[data-pb-root]')) {
    SIMPLE = themeOptionInputs('Bead Size').length > 0 && themeOptionInputs('Wrist Size').length > 0;
    if (!SIMPLE) return;
  }
  document.querySelectorAll('[data-pbprev-gate]').forEach(function (el) { el.hidden = false; });
  document.body.classList.add('pbprev-active');
  /* the tray drew before the pearl tab was unhidden: nudge the register's
     OWN redraw (a change event from a real, still-unchecked input) so the
     pearl's + box appears once, from one owner - a hand-seeded box doubled
     up whenever the register redrew on its own */
  setTimeout(function () {
    var inp = document.querySelector('.pixiu-builder input[data-pb-pearl]');
    if (!inp) return;
    window.__pbprevNudge = true;            /* not a real edit - must NOT reveal */
    inp.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () { window.__pbprevNudge = false; }, 60);
  }, 150);
  /* the preview stays hidden until the customer actually chooses something -
     the listing must look completely normal on first load (owner, 10 Aug) */
  var touched = true;   /* preview stays hidden until a wrist size is chosen
     (owner, 20 Aug) - no dashed placeholder ring */
  var homeParent = wrap.parentNode, homeNext = wrap.nextSibling;
  /* mobile: the preview joins the photo gallery as the FIRST slide and the
     whole hero becomes a swipe row; on desktop it lives above the gallery.
     Re-homes on resize so a laptop window dragged narrow behaves like a
     phone and back. */
  function placeForViewport() {
    if (SIMPLE) return;   /* stays where the snippet rendered it, all viewports */
    if (!touched) return;
    var nav = document.querySelector('.productView-nav');
    if (!nav) return;
    var iw = document.querySelector('.productView-image-wrapper');
    if (window.innerWidth <= 767) {
      /* phone (owner, 10 Aug): photos stay the swipeable hero, then title /
         subtitle / price, then the preview at the top of the register with
         the tray boxes driving pop-out sheets - the custom builder's flow */
      nav.classList.add('pbprev-swipe');
      if (reg) {
        reg.classList.add('pbprev-sheets');
        if (wrap.parentNode !== reg) reg.insertBefore(wrap, reg.firstChild);
        /* the ? helpers sit to the RIGHT of the PEARL and CHARM labels
           under the boxes. They live in a stable sibling row (the tray
           itself is wiped on every redraw) and are positioned per slot. */
        var qrow = reg.querySelector('.pbprev-qrow');
        var trayN = reg.querySelector('.pb-tray');
        if (!qrow && trayN) {
          qrow = document.createElement('div');
          qrow.className = 'pbprev-qrow';
          trayN.parentNode.insertBefore(qrow, trayN.nextSibling);
        }
        ['[data-pb-pearl-info-open]', '[data-pb-addon-guide-open]'].forEach(function (sel) {
          var q = reg.querySelector(sel);
          if (q && qrow && q.parentNode !== qrow) { q._pbHome = q._pbHome || q.parentNode; qrow.appendChild(q); }
        });
        positionQs();
      }
    } else {
      nav.classList.remove('pbprev-swipe');
      if (reg) {
        reg.classList.remove('pbprev-sheets', 'pbprev-sheetopen');
        reg.querySelectorAll('[data-pb-pearl-info-open], [data-pb-addon-guide-open]').forEach(function (q) {
          if (q._pbHome && q.parentNode !== q._pbHome) q._pbHome.appendChild(q);
        });
      }
      if (wrap.parentNode !== homeParent) homeParent.insertBefore(wrap, homeNext);
    }
  }
  var rzT = null;
  window.addEventListener('resize', function () {
    clearTimeout(rzT);
    rzT = setTimeout(function () { placeForViewport(); paint(); }, 150);
  });
  /* Desktop (owner, 13 Aug): the preview only appears once a BEAD SIZE is
     chosen. Owner, 20 Aug: BOTH viewports also wait for a WRIST SIZE -
     the empty dashed ring never shows at all. */
  function beadChosen() {
    var panel = document.querySelector('.pixiu-builder [data-pb-panel="bead"]');
    if (!panel) return true;   /* fixed-bead products have no bead tab at all */
    return !!panel.querySelector('input[type="radio"]:checked');
  }
  function wristChosen() {
    /* same signal paint() trusts: the dropdown trigger carries the chosen
       option id. No trigger at all = old markup, do not gate on it. */
    var ddt = document.querySelector('.pixiu-builder [data-pb-dd-trigger]');
    return !ddt || !!ddt.dataset.ovid;
  }
  function reveal() {
    if (!wristChosen() || (window.innerWidth > 767 && !beadChosen())) { wrap.hidden = true; return; }
    wrap.hidden = false;
    placeForViewport();
  }
  setTimeout(reveal, 80);

  var stage = wrap.querySelector('.pbprev-stage');
  var ring = wrap.querySelector('.pbprev-ring');
  var reg = document.querySelector('.pixiu-builder');
  /* tray boxes open the active tab panel as a bottom sheet on the phone */
  if (reg) {
    reg.querySelectorAll('.pb-tabpanel').forEach(function (pn) {
      if (pn.querySelector('.pbprev-sheet-x')) return;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'pbprev-sheet-x';
      x.setAttribute('aria-label', 'Close');
      x.textContent = '\u00d7';
      x.addEventListener('click', function () { reg.classList.remove('pbprev-sheetopen'); });
      pn.insertBefore(x, pn.firstChild);
      var done = document.createElement('button');
      done.type = 'button';
      done.className = 'pbprev-sheet-done';
      done.textContent = 'CONFIRM';
      done.addEventListener('click', function () { reg.classList.remove('pbprev-sheetopen'); });
      pn.appendChild(done);
    });
    document.addEventListener('click', function (e) {
      if (!reg.classList.contains('pbprev-sheets')) return;
      var slot = e.target.closest && e.target.closest('.pb-tray .pb-slot');
      if (!slot) return;
      reg.classList.add('pbprev-sheetopen');
      /* activate by the box's own label - never by index or per-slot
         listeners, which drifted when the tray composition changed */
      var lab = slot.getAttribute('data-pbprev-lab');
      /* the slot's own panel key is authoritative (label mapping kept as
         the fallback for markup predating the data-pb-slot-key tags) */
      var key = (slot.dataset && slot.dataset.pbSlotKey)
        || (lab === 'BEAD' ? 'bead' : lab === 'PIXIU' ? 'pixiu' : lab === 'PEARL' ? 'pearl' : lab === 'CHARM' ? 'meta-1' : null);
      if (key) setTimeout(function () {
        var tb = reg.querySelector('[data-pb-tab="' + key + '"]');
        if (tb) tb.click();
      }, 0);
    }, true);
    /* labels under the boxes, in tray order - re-applied whenever the
       register redraws the tray (write-on-change only) */
    function positionQs() {
      var qrow = reg.querySelector('.pbprev-qrow');
      var trayN = reg.querySelector('.pb-tray');
      if (!qrow || !trayN || !reg.classList.contains('pbprev-sheets')) return;
      [['PEARL', '[data-pb-pearl-info-open]'], ['CHARM', '[data-pb-addon-guide-open]']].forEach(function (pr) {
        var q = qrow.querySelector(pr[1]);
        if (!q) return;
        var slot = Array.prototype.find.call(trayN.querySelectorAll('.pb-slot'), function (s2) {
          return s2.getAttribute('data-pbprev-lab') === pr[0];
        });
        if (!slot) { q.style.display = 'none'; return; }
        q.style.display = '';
        q.style.position = 'absolute';
        /* park the ? 4px after the label word ENDS (owner, 20 Aug: "the ?
           is too far from the word"). The word is centred under the slot,
           so use its rendered width - and measure slot and qrow in the
           SAME coordinate space: offsetLeft mixed origins and silently
           shifted the ? ~10px right. */
        var lw = 0;
        try { lw = parseFloat(getComputedStyle(slot, '::after').width) || 0; } catch (e) { }
        var sr = slot.getBoundingClientRect(), qr = qrow.getBoundingClientRect();
        q.style.left = (sr.left - qr.left + sr.width / 2 + (lw ? lw / 2 + 4 : 22)) + 'px';
        q.style.top = '-24px';
      });
    }
    function labelTray() {
      var slots = reg.querySelectorAll('.pb-tray .pb-slot');
      /* label each box by ITS OWN panel key (the register tags every slot
         with data-pb-slot-key). The old index-based list assumed a BEAD box
         always exists; on listings with no bead option the labels shifted
         one over, so the pearl box said PIXIU and taps opened the wrong
         sheet (found 29 Oct). Index labels stay as the fallback for
         markup predating the tags. */
      var BYKEY = { bead: 'BEAD', pixiu: 'PIXIU', pearl: 'PEARL' };
      var labs = slots.length >= 4 ? ['BEAD', 'PIXIU', 'PEARL', 'CHARM'] : ['BEAD', 'PIXIU', 'CHARM'];
      slots.forEach(function (sl, i) {
        var key = sl.dataset ? sl.dataset.pbSlotKey : null;
        var want = key ? (BYKEY[key] || 'CHARM') : (labs[i] || '');
        if (sl.getAttribute('data-pbprev-lab') !== want) sl.setAttribute('data-pbprev-lab', want);
      });
      positionQs();
    }
    labelTray();
    /* bead pop-out shows size chips like the custom builder's SIZE (MM) row:
       the mm text lives INSIDE the cell; the photo and caption hide in CSS */
    reg.querySelectorAll('[data-pb-panel="bead"] .pb-cell').forEach(function (c) {
      if (c.querySelector('.pbprev-mm')) return;
      var inp = c.querySelector('input');
      var m = inp && String(inp.value).match(/\d+(?:\.\d+)?/);
      if (!m) return;
      var sp = document.createElement('span');
      sp.className = 'pbprev-mm';
      sp.textContent = m[0] + 'MM';
      c.appendChild(sp);
    });
    var trayEl = reg.querySelector('.pb-tray');
    if (trayEl) new MutationObserver(function () { labelTray(); }).observe(trayEl, { childList: true });
  }
  var BEAD_IMG = wrap.getAttribute('data-bead-img');
  var PEARL_IMG = wrap.getAttribute('data-pearl-img');
  var PEARL_MM = 9;

  /* ── ported constants (v2) ─────────────────────────────────────────── */
  var R = 40, CIRC_PCT = 2 * Math.PI * R;
  /* COUNT math stays exactly the custom builder's (0.95 / 0.72): these two
     feed capacity and bead count only. The LAYOUT constants below are the
     owner-tuned draw-only spacing - visual, never counted. */
  var SINGLE_RESERVE_W = 0.95;
  var SIDE_RESERVE_W = 0.72;
  /* EXACTLY the custom builder's numbers: it draws the dragon at its full
     length while reserving 0.74 of that length as layout slot, so the beads
     tuck under the photo's transparent edges. Do not re-tune these -
     copy v2 (bracelet-builder-2d-v2.js) if they ever change. */
  /* slot values follow the custom builder's soloSlot(): 0.74 x BEAD_TIGHT,
     then scaled by how much of the photo is ACTUAL dragon, so every size in
     the ladder leaves the same small gap. Copy v2 if it ever changes. */
  /* EXACTLY the custom builder's working recipe (13 Aug): a FLAT 0.74 slot
     (0.72 for a pair), the dragon drawn at full length with only its
     per-photo PIX_DISPLAY tweak - no BEAD_TIGHT on the dragon, no art
     centring. Copy v2 if it ever changes; do not add scaling here. */
  function soloSlotW() { return 0.74; }
  /* owner, 20 Aug: pair gap a little smaller - layout slot only, capacity
     (SIDE_RESERVE_W) stays 0.72 so bead counts are untouched. Same value
     as v2's SIDE_LAYOUT_W; change both files together. */
  function sideSlotW() { return 0.66; }
  /* measured against the custom builder (gold mini pair): it renders the
     dragon at 18.8mm apparent vs 14.3 here, so scale drawing by the ratio.
     Draw-only - reserve/physics untouched. */
  /* dragons draw with the SAME tightening the beads got (BEAD_TIGHT), or
     they read ~21% small beside them - owner, 13 Aug */
  var DRAGON_MATCH = 1.315 * 1.21;
  /* solo dragon measured the same way: custom renders the mini at 12.6mm
     apparent vs 25.9 here, so the solo path scales by 0.64 overall.
     (A per-size ladder matching the custom's 22/24mm classic/grande was
     tried 10 Aug and REVERTED - at that size the dragon overlaps the
     beads because the layout slot stays 0.62 of len. Owner preferred
     this uniform look.) */
  var SOLO_MATCH = 0.64 * 1.21;
  function soloMatch() { return SOLO_MATCH; }
  var TIMES = '×';
  var SIDE_FORESHORTEN_W = 1.0;
  /* draw-only: beads render at ~85% of their mm after fill compensation,
     which read as gaps; tighten so neighbours look about to touch */
  /* 1.21 -> 1.17 (owner, 24 Aug: beads overlapped "a tiny tiny bit" too
     much on 12mm jade). Same value in v2; change both files together. */
  var BEAD_TIGHT = 1.17;
  /* side-profile pair art, same files the custom builder serves (its
     pixiuSide map). Midi shares the Classic side art; silver grande
     intentionally reuses the silver mini photo, as in the custom builder. */
  var SIDE_IMG = {
    goldmini: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_gold_mini_240x.png',
    goldmidi: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_gold_classic_240x.png',
    goldclassic: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_gold_classic_240x.png',
    goldgrande: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_gold_grande_7bd47cf0-1db8-49fa-bb08-117a2766fb29_240x.png',
    silvermini: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_silver_mini_240x.png',
    silvermidi: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_silver_classic_240x.png',
    silverclassic: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_silver_classic_240x.png',
    silvergrande: 'https://www.serenityartnhome.com/cdn/shop/files/pixiu_side_silver_mini_240x.png'
  };
  function sideImgFor(name) {
    var n = String(name).toLowerCase();
    var fin = n.indexOf('silver') >= 0 ? 'silver' : 'gold';
    var sz = n.indexOf('midi') >= 0 ? 'midi' : n.indexOf('classic') >= 0 ? 'classic' : n.indexOf('grande') >= 0 ? 'grande' : 'mini';
    return SIDE_IMG[fin + sz] || null;
  }
  var PIX_DISPLAY = {};
  PIX_DISPLAY['Silver Classic - 26 ' + TIMES + ' 11mm'] = 0.95;
  PIX_DISPLAY['Silver Midi - 20 ' + TIMES + ' 9mm'] = 0.95;
  PIX_DISPLAY['Gold Mini - 17 ' + TIMES + ' 9mm'] = 1.10;

  function pos(el, deg) {
    var a = (deg - 90) * Math.PI / 180;
    el.style.left = (50 + Math.cos(a) * R) + '%';
    el.style.top = (50 + Math.sin(a) * R) + '%';
  }
  function chordPct(deg) { return 2 * R * Math.sin(deg * Math.PI / 360); }
  function ringPoint(deg) {
    var a = (deg - 90) * Math.PI / 180;
    return { x: 50 + Math.cos(a) * R, y: 50 + Math.sin(a) * R };
  }

  /* photo-crop compensation, ported: identical mm must READ identical */
  var IMG_FILL = {}, IMG_FILLW = {}, IMG_OFFX = {}, IMG_OFFY = {}, IMG_FILL_PENDING = {};
  var REF_FILL = 0.85;
  function fillRatio(src) {
    if (IMG_FILL[src] != null) return IMG_FILL[src];
    if (!IMG_FILL_PENDING[src]) {
      IMG_FILL_PENDING[src] = 1;
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var N = 128, cv = document.createElement('canvas'); cv.width = N; cv.height = N;
          var cx2 = cv.getContext('2d'); cx2.drawImage(im, 0, 0, N, N);
          var d = cx2.getImageData(0, 0, N, N).data;
          var minX = N, minY = N, maxX = -1, maxY = -1;
          for (var y = 0; y < N; y++) for (var x = 0; x < N; x++) {
            if (d[(y * N + x) * 4 + 3] > 16) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
          }
          var bw = (maxX - minX + 1) / N, bh = (maxY - minY + 1) / N, r;
          if (maxX < 0) { r = REF_FILL; }
          else if (Math.abs(bw - bh) < 0.06) { r = (bw + bh) / 2; }
          else { r = Math.max(bw, bh); }
          IMG_FILL[src] = Math.min(1, Math.max(0.4, r));
          IMG_FILLW[src] = Math.min(1, Math.max(0.3, bw));   /* opaque width share: dragons */
          /* horizontal centre of the opaque art, as a fraction of the canvas:
             positive = art sits right of centre. Used to centre the solo
             dragon between its beads (the photo art is off-centre). */
          IMG_OFFX[src] = maxX < 0 ? 0 : (((minX + maxX + 1) / 2) - N / 2) / N;
          IMG_OFFY[src] = maxY < 0 ? 0 : (((minY + maxY + 1) / 2) - N / 2) / N;
        } catch (e) { IMG_FILL[src] = REF_FILL; }
        paint();
      };
      im.onerror = function () { IMG_FILL[src] = REF_FILL; };
      im.src = src;
    }
    return null;
  }
  function sizeComp(src) {
    var f = fillRatio(src);
    return f ? Math.min(1.6, Math.max(0.7, REF_FILL / f)) : 1;
  }
  /* dragons: the register photos carry heavy transparent padding, so draw
     them so the OPAQUE body spans the reserved chord */
  /* pearls: some photos sit off-centre in their canvas (the gold coin rode
     high-left); centre the OPAQUE art in the slot on both axes */
  function pearlCentre(src) {
    fillRatio(src);
    var ox = (IMG_OFFX[src] || 0) * 100, oy = (IMG_OFFY[src] || 0) * 100;
    return 'translate(calc(-50% - ' + ox.toFixed(1) + '%), calc(-50% - ' + oy.toFixed(1) + '%))';
  }
  function dragonComp(src) {
    fillRatio(src);
    var bw = IMG_FILLW[src];
    return bw ? Math.min(2.4, Math.max(1, 1 / bw)) : 1;
  }

  /* ── read the register's current choices ───────────────────────────── */
  function beadMm() {
    var r2 = SIMPLE ? themeChecked('Bead Size')
      : reg && reg.querySelector('[data-pb-panel="bead"] input[type="radio"]:checked');
    var m = r2 && String(r2.value).match(/(\d+(?:\.\d+)?)/);
    return m ? Math.round(parseFloat(m[1])) : 8;
  }
  function beadImg() {
    /* the ring draws the CHOSEN bead's photo (Medium vs Dark Green), not
       one fixed image (owner, 20 Aug). The tray cell already shows the
       right swatch; reuse its src at a ring-friendly resolution. */
    var r2 = reg && reg.querySelector('[data-pb-panel="bead"] input[type="radio"]:checked');
    var im = r2 && r2.closest('label') && r2.closest('label').querySelector('img.pb-bead-img');
    var src = im && im.getAttribute('src');
    return src ? src.replace('width=128', 'width=256') : BEAD_IMG;
  }
  function beadMix() {
    /* mixed-bead products (owner, 25 Aug: lava + obsidian alternating).
       A bead value reads "<Amm> <StoneA> / <Bmm> <StoneB>"; the ring then
       alternates the two stones, stone B (listed second, e.g. obsidian)
       sitting beside the dragon like the product photo. Photos come from
       the two mix rows the panel renders. */
    var r2 = reg && reg.querySelector('[data-pb-panel="bead"] input[type="radio"]:checked');
    var v = (r2 && r2.value) || '';
    var m = v.match(/^(\d+(?:\.\d+)?)mm\s+(.+?)\s*\/\s*(\d+(?:\.\d+)?)mm\s+(.+)$/);
    if (!m) return null;
    var ga = reg.querySelector('[data-pb-mixrow="a"] img');
    var gb = reg.querySelector('[data-pb-mixrow="b"] img');
    var up = function (im) { return im ? im.getAttribute('src').replace('width=128', 'width=256') : BEAD_IMG; };
    return { m1: parseFloat(m[1]), m2: parseFloat(m[3]), img1: up(ga), img2: up(gb) };
  }
  function wristCm() {
    if (SIMPLE) {
      var w2 = themeChecked('Wrist Size');
      var wm = w2 && String(w2.value).match(/(\d+(?:\.\d+)?)/);
      return wm ? parseFloat(wm[1]) : 16;
    }
    var el = reg && (reg.querySelector('[data-pb-dd-trigger][data-label]') || reg.querySelector('select[data-pb-select]'));
    var label = '';
    if (el) label = el.dataset ? (el.dataset.label || '') : '';
    if (!label && el && el.selectedOptions && el.selectedOptions[0]) label = el.selectedOptions[0].textContent;
    var m = String(label).match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 16;
  }
  function pixiu() {
    var r2 = reg && reg.querySelector('[data-pb-panel="pixiu"] input[type="radio"]:checked');
    if (!r2) return null;
    var img = r2.closest('label') && r2.closest('label').querySelector('img');
    var name = r2.value || r2.dataset.label || '';
    var m = String(name).match(/(\d+(?:\.\d+)?)\s*(?:×|x)/i);
    var len = m ? parseFloat(m[1]) : 17;
    return { img: img ? img.src : null, len: len, v: name };
  }
  function charm() {
    var r2 = reg && reg.querySelector('[data-pb-addon]:checked');
    if (!r2) return null;
    var img = r2.closest('label') && r2.closest('label').querySelector('img.pb-charm-img');
    return img ? { img: img.src, name: r2.value || '' } : null;
  }
  function pairOn() {
    var b = document.querySelector('[data-pb-pixcount="2"]');
    return b && b.classList.contains('is-active');
  }
  function pearlSel() {
    var r2 = reg && reg.querySelector('input[data-pb-pearl]:checked');
    if (!r2 || !r2.value) return null;
    return { img: r2.dataset.img + '?width=160', mm: parseFloat(r2.dataset.mm) || 9 };
  }
  /* one pearl each side of the pixiu (owner, 21 Oct 2026); single-dragon only */
  function pearlTwo() {
    var c = reg && reg.querySelector('[data-pb-pearl-count="2"]');
    return !!(c && c.classList.contains('on'));
  }

  /* iOS ignores CSS scrollbar colours entirely, so the wrist list gets a
     JS-drawn black thumb (a span - the theme hides empty divs) */
  (function () {
    var list = reg && reg.querySelector('.pb-row--size .pb-dd-list');
    if (!list) return;
    var th = document.createElement('span');
    th.className = 'pbprev-ddthumb';
    list.appendChild(th);
    function syncThumb() {
      var h = list.clientHeight, sh = list.scrollHeight;
      if (sh <= h + 2) { th.style.display = 'none'; return; }
      th.style.display = 'block';
      var tH = Math.max(24, h * h / sh);
      th.style.height = tH + 'px';
      th.style.top = (list.scrollTop + (list.scrollTop / (sh - h)) * (h - tH)) + 'px';
    }
    list.addEventListener('scroll', syncThumb, { passive: true });
    var trg = reg.querySelector('.pb-row--size [data-pb-dd-trigger]');
    if (trg) trg.addEventListener('click', function () { setTimeout(syncThumb, 60); });
  })();

  /* zoom slider under the preview */
  var zoomVal = 1;   /* both views start at 1x (owner, 13 Aug); the desktop
     slider takes it up to the screen-fitted ceiling */
  var zoomCtl = wrap.querySelector('.pbprev-zoomctl');
  if (zoomCtl) { zoomCtl.value = '1'; }
  var zoomV = wrap.querySelector('.pbprev-zoomv');
  function syncZoomReadout() {
    if (!zoomCtl || !zoomV) return;
    var v = parseFloat(zoomCtl.value) || 1, mx = parseFloat(zoomCtl.max) || 2.5;
    var pct = mx > 1 ? (v - 1) / (mx - 1) : 0;
    zoomV.style.left = (pct * (zoomCtl.offsetWidth - 13) + 6.5) + 'px';
    zoomV.textContent = (Math.round(v * 10) / 10).toString().replace(/\.0$/, '') + 'x';
  }
  if (zoomCtl) zoomCtl.addEventListener('input', function () {
    zoomVal = parseFloat(zoomCtl.value) || 1;
    syncZoomReadout();
    paint();
  });
  setTimeout(syncZoomReadout, 100);

  /* ── paint ─────────────────────────────────────────────────────────── */
  function paint() {
    if (!ring) return;
    ring.innerHTML = '';
    var bMm = beadMm();
    var BIMG = beadImg();
    /* until a wrist size is chosen: dashed empty bead slots, like the
       custom builder's empty ring */
    var ddt = reg && reg.querySelector('[data-pb-dd-trigger]');
    var hint = wrap.querySelector('[data-pbprev-hint]');
    var wristSet = SIMPLE ? !!themeChecked('Wrist Size') : !!(ddt && ddt.dataset.ovid);
    var beadPanel = reg && reg.querySelector('[data-pb-panel="bead"]');
    var beadSet = SIMPLE ? !!themeChecked('Bead Size')
      : (beadPanel ? !!beadPanel.querySelector('input[type="radio"]:checked') : true);
    if (hint) {
      /* simple mode has no tray boxes: the pickers sit beside the preview */
      var hw = SIMPLE ? 'DRAWN TO YOUR SIZE' : (wristSet ? 'TAP EACH BOX TO CUSTOMISE YOUR BRACELET' : 'START WITH YOUR WRIST SIZE');
      if (hint.textContent !== hw) hint.textContent = hw;
    }
    /* the ring stays as empty slots until BOTH wrist and bead are chosen */
    if (!wristSet || !beadSet) {
      var phChain = 16 * 10 + 29;
      var phN = Math.max(1, Math.floor(phChain / bMm));
      var MAXPH = (window.innerWidth <= 860 ? 19 * 10 + 29 : 24 * 10 + 29);
      ring.style.transformOrigin = '50% 50%';
      ring.style.transform = 'scale(' + Math.min(1, phChain / MAXPH) * (zoomVal) + ')';
      var phW = 360 * bMm / phChain;
      var phGap = (360 - phN * phW) / phN;
      for (var k0 = 0; k0 < phN; k0++) {
        /* span, not div: base.css hides every empty div site-wide */
        var ph = document.createElement('span');
        ph.className = 'pbprev-ph';
        pos(ph, (phGap / 2 + k0 * (phW + phGap) + phW / 2) % 360);
        ph.style.width = (CIRC_PCT * bMm * 0.86 / phChain) + '%';
        ring.appendChild(ph);
      }
      return;
    }
    var mix = beadMix();
    /* alternating stones: counts use the average width, the cluster beads
       beside the dragons use stone B (obsidian in the product photo) */
    var avgMm = mix ? (mix.m1 + mix.m2) / 2 : bMm;
    var cMm = mix ? mix.m2 : bMm;
    var cImg = mix ? mix.img2 : BIMG;
    var px = pixiu();
    var pair = pairOn() && px;
    var pearl = pearlSel();
    var PMM = pearl ? pearl.mm : PEARL_MM;
    var ch = charm();
    var pixW = px ? px.len : 0;
    /* v2 reserve rules: solo dragon 0.95 of len; each dragon of a pair 0.72,
       plus the bridge beads and the centre pearl */
    /* capacity/count use the v2 reserves; layout uses the tighter values */
    var capBlock = 0, pixBlock = 0;
    var pairPixW = px ? pixW * sideSlotW(px.img) : 0;
    if (px) {
      capBlock = pair
        ? pixW * SIDE_RESERVE_W * 2 + (pearl ? cMm * 2 + PMM : cMm)
        : pixW * SINGLE_RESERVE_W;
      /* v2 cluster: with a pearl the pair is dragon|bead|pearl|bead|dragon;
         without one, a SINGLE bead bridges the two dragons */
      pixBlock = pair
        ? pairPixW * 2 + (pearl ? cMm * 2 + PMM : cMm)
        : pixW * soloSlotW(px.img);   /* px is non-null inside this branch */
    }
    var pearlN = (!pair && pearl) ? (pearlTwo() ? 2 : 1) : 0;
    var cap = Math.max(0, (wristCm() * 10 + 29) - capBlock - PMM * pearlN);
    var n = Math.max(1, Math.floor(cap / avgMm));
    var chain = Math.max(1, n * avgMm + pixBlock + PMM * pearlN);
    function mmToDeg(mm) { return 360 * mm / chain; }
    function mmToPct(mm) { return CIRC_PCT * mm / chain; }

    /* scale the whole ring like v2: absolute size against a 24cm reference */
    var MAXCHAIN = (window.innerWidth <= 860 ? 19 * 10 + 29 : 24 * 10 + 29);
    var ratio = Math.min(1, chain / MAXCHAIN);
    ring.style.transformOrigin = '50% 50%';
    /* the zoom ceiling depends on the screen, like the custom builder: the
       enlarged ring may fill the square but never spill past it */
    if (stage && zoomCtl && !wrap.hidden) {   /* a hidden stage measures 0 and
        would poison the clamp before the preview ever shows */
      var sw2 = stage.getBoundingClientRect().width || 412;
      var fw2 = Math.min(412, sw2 * 0.92);
      /* up to 3x, but never past what the screen can hold (owner, 10 Aug) */
      var zmax = Math.max(1, Math.min(3, sw2 / (fw2 * ratio * 0.95)));
      zoomCtl.max = zmax.toFixed(2);
      if (zoomVal > zmax) { zoomVal = zmax; zoomCtl.value = zmax.toFixed(2); }
      syncZoomReadout();
    }
    ring.style.transform = 'scale(' + (ratio * zoomVal) + ')';

    var blockDeg = pixBlock ? mmToDeg(pixBlock) : 0;
    var start = 180 + blockDeg / 2;
    var span = Math.max(0.001, 360 - blockDeg);

    /* items around the free arc: beads, one may be replaced by the charm and
       (single-dragon mode) one by the pearl beside the dragon */
    var items = [];
    /* i=0 sits beside the dragon block, so stone B (obsidian) leads and,
       for odd counts, also closes the ring - matching the real bracelet */
    for (var i = 0; i < n; i++) items.push(mix
      ? { k: 'bead', mm: (i % 2 ? mix.m1 : mix.m2), img: (i % 2 ? mix.img1 : mix.img2) }
      : { k: 'bead', mm: bMm, img: BIMG });
    if (!pair && pearl && n > 1) items.splice(1, 0, { k: 'pearl' }); /* v2 PEARL_HOME: one bead from the dragon */
    /* second pearl mirrors the first: one bead from the dragon's OTHER side */
    if (!pair && pearl && pearlTwo() && n > 2) items.splice(items.length - 1, 0, { k: 'pearl' });
    if (ch && items.length > 2) {
      /* v2 rule: the charm replaces the bead that best balances the strand
         width each side, so it sits at the TOP CENTRE; ties go right */
      var widths0 = items.map(function (it) { return it.k === 'pearl' ? PMM : (it.mm || bMm); });
      var tot0 = widths0.reduce(function (a, b2) { return a + b2; }, 0);
      var best = 1, bestD = 1e9, acc = 0;
      for (var k2 = 0; k2 < items.length; k2++) {
        if (items[k2].k === 'bead') {
          var mid = acc + widths0[k2] / 2;
          var dd = Math.abs(mid - tot0 / 2);
          if (dd <= bestD) { bestD = dd; best = k2; }
        }
        acc += widths0[k2];
      }
      items[best] = { k: 'charm' };
    }
    var chPush = ch && /protection|zodiac guardian ring/i.test(ch.name);
    var degs = items.map(function (it) {
      /* v2: thin cylinder charms thread BETWEEN beads on ~6mm of strand,
         not a full bead slot - a bead-wide slot left gaps either side */
      if (it.k === 'pearl') return mmToDeg(PMM);
      if (it.k === 'charm') return mmToDeg(chPush ? 4 : avgMm);
      return mmToDeg(it.mm || bMm);
    });
    var used = degs.reduce(function (a, b) { return a + b; }, 0);
    var gap = (span - used) / (items.length + 1);
    var cum = 0;
    items.forEach(function (it, k) {
      var d = (start + gap * (k + 1) + cum + degs[k] / 2) % 360;
      cum += degs[k];
      var el = document.createElement('img');
      el.className = 'pbprev-bead';
      if (it.k === 'bead') { el.src = it.img || BIMG; el.style.width = mmToPct((it.mm || bMm) * sizeComp(el.src) * BEAD_TIGHT) + '%'; }
      else if (it.k === 'pearl') {
        el.src = pearl.img;
        el.style.width = mmToPct(PMM * sizeComp(pearl.img) * BEAD_TIGHT) + '%';
        el.style.transform = pearlCentre(pearl.img);
      }
      else {
        el.src = ch.img;
        var comp = sizeComp(ch.img);
        /* v2 rules: thin cylinder charms thread the strand and keep their
           photo's own proportions at ~10mm height; round charms draw at
           their mm. Both rotate to the slot's ring angle, perpendicular to
           the strand, exactly as the custom builder does. */
        var isPush = chPush;
        if (isPush) {
          (function (el2) {
            var fitPush = function () {
              var w = el2.naturalWidth, h = el2.naturalHeight;
              el2.style.width = (mmToPct(10 * comp) * (w && h ? w / h : 1)) + '%';
            };
            fitPush();
            if (!el2.complete) el2.addEventListener('load', fitPush);
          })(el);
        } else {
          el.style.width = mmToPct(bMm * 1.15 * comp) + '%';
        }
        el.style.transform = 'translate(-50%,-50%) rotate(' + (((d % 360) + 360) % 360) + 'deg)';
      }
      el.alt = '';
      pos(el, d);
      ring.appendChild(el);
    });

    if (px && px.img) {
      var pieces = pair
        ? (pearl
            ? [{ k: 'pix', w: pairPixW, flip: false }, { k: 'bead', w: cMm },
               { k: 'centre', w: PMM },
               { k: 'bead', w: cMm }, { k: 'pix', w: pairPixW, flip: true }]
            : [{ k: 'pix', w: pairPixW, flip: false }, { k: 'bead', w: cMm },
               { k: 'pix', w: pairPixW, flip: true }])
        : [{ k: 'pix', w: pixW * soloSlotW(px.img), flip: false }];
      var cursor = 0, clusterStart = 180 - blockDeg / 2;
      pieces.forEach(function (pc) {
        var midDeg = clusterStart + mmToDeg(cursor + pc.w / 2);
        cursor += pc.w;
        var el = document.createElement('img'); el.alt = '';
        if (pc.k === 'pix') {
          el.className = 'pbprev-orn';
          var side = pair ? sideImgFor(px.v) : null;
          if (side) {
            /* verbatim from the custom builder: side profile lies along the
               ring's tangent; rotation is the chord from the dragon's OUTER
               end to its INNER end, +180. Left dragon mirrors X+Y, right X. */
            el.src = side;
            el.style.width = (chordPct(mmToDeg(pc.w)) * (PIX_DISPLAY[px.v] || 1) * SIDE_FORESHORTEN_W) + '%';
            var sp = mmToDeg(pc.w);
            var ie = ringPoint(pc.flip ? (midDeg - sp / 2) : (midDeg + sp / 2));
            var oe = ringPoint(pc.flip ? (midDeg + sp / 2) : (midDeg - sp / 2));
            var pairAng = Math.atan2(ie.y - oe.y, ie.x - oe.x) * 180 / Math.PI + 180;
            var pairMir = pc.flip ? ' scaleX(-1)' : ' scaleX(-1) scaleY(-1)';
            el.style.transform = 'translate(-50%,-50%) rotate(' + (pairAng + 180).toFixed(1) + 'deg)' + pairMir;
          } else {
            el.src = px.img;
            /* the custom builder's own formula: chord of the dragon's FULL
               length, its per-photo PIX_DISPLAY tweak, and BEAD_TIGHT so it
               reads correctly beside the tightened beads. The old hand-tuned
               DRAGON_MATCH / SOLO_MATCH factors drew it undersized. */
            el.style.width = (chordPct(mmToDeg(pixW)) * (PIX_DISPLAY[px.v] || 1)) + '%';
            if (pc.flip) el.style.transform = 'translate(-50%,-50%) scaleX(-1)';
          }
        } else if (pc.k === 'centre') {
          el.className = 'pbprev-bead';
          el.src = pearl ? pearl.img : cImg;
          el.style.width = mmToPct(pc.w * sizeComp(el.src) * BEAD_TIGHT) + '%';
          if (pearl) el.style.transform = pearlCentre(pearl.img);
        } else {
          el.className = 'pbprev-bead';
          el.src = cImg;
          el.style.width = mmToPct(cMm * sizeComp(cImg) * BEAD_TIGHT) + '%';
        }
        pos(el, midDeg);
        ring.appendChild(el);
      });
    }
  }

  /* ── wire: repaint on any register change + preview control taps ───── */
  var t = null;
  function queue() { clearTimeout(t); t = setTimeout(paint, 60); }
  if (reg) {
    reg.addEventListener('change', function () {
      if (!window.__pbprevNudge) reveal();   /* the load-time tray nudge is not an edit */
      queue();
    }, true);
    /* wrist size arrives via the custom dropdown, which fires no change
       event - so clicks must re-check reveal too */
    reg.addEventListener('click', function () { setTimeout(function () { reveal(); queue(); }, 80); }, true);
  }
  if (SIMPLE) {
    /* the theme's variant pickers fire real change events; the sticky form
       duplicates them, so listen at the document and repaint on any */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"][name="Bead Size"], input[type="radio"][name="Wrist Size"]')) {
        SIMPLE_SEL[e.target.name] = e.target.value;
        reveal(); queue();
      }
    }, true);
  }
  document.addEventListener('click', function (e) {
    var seg = e.target.closest && e.target.closest('[data-pb-pixcount]');
    if (!seg) return;
    document.querySelectorAll('[data-pb-pixcount]').forEach(function (b) { b.classList.toggle('is-active', b === seg); });
    reveal(); paint();
  });
  paint();
})();
